<template>
  <div class="wrapper">
    <div class="thesisTitle">
      <div class="nameSide">论文名称</div>
      <div class="btnSide">
        <!-- <el-button type="primary" size="mini" @click="scoreRuleIfShow = true"
          >评分规则</el-button
        > -->
      </div>
    </div>
    <div class="thesisContainer">
      <div class="thesisShow" v-loading="!pdfData.pdfIfShow">
        <pdf-preview
          :url="pdfData.pdfUrl"
          v-if="pdfData.pdfIfShow"
        ></pdf-preview>
      </div>
      <div class="thesisInAll" v-if="paperList.length">
        <div class="detail">考生：{{ paperList[paperIndex].userName }}</div>
        <div class="detail">
          提交时间：{{ paperList[paperIndex].createTime }}
        </div>
        <div class="scoreList">
          <div class="titleBar scoreBar">
            <div class="cell">评分项</div>
            <div class="cell">总分</div>
            <div class="cell">得分</div>
          </div>
          <div
            class="scoreBar"
            v-for="score in paperList[paperIndex].scoreItemList"
          >
            <div class="cell">{{ score.scoreItemName }}分</div>
            <div class="cell">{{ score.maxScore }}</div>
            <div class="cell">
              <!-- <el-input-number
                v-model="score.score"
                :precision="1"
                :step="0.1"
                :max="score.maxScore"
                :min="0"
                class="scoreInput"
              ></el-input-number> -->

              <input
                type="number"
                v-model="score.score"
                :style="0.1"
                @change="(e) => valueCheck(e.target.value, score)"
                class="scoreInput"
              />
            </div>
          </div>
          <div class="titleBar scoreBar">
            <div class="cell">总分</div>
            <div class="cell">
              {{
                paperList[paperIndex].scoreItemList.reduce(
                  (total, value) => total + Number(value.maxScore),
                  0
                )
              }}分
            </div>
            <div class="cell">
              <!-- {{ paperList[paperIndex].scoreItemList | totalScoreCalc }} -->
              {{
                paperList[paperIndex].scoreItemList.reduce((total, value) => {
                  return (Number(total) * 10 + Number(value.score) * 10) / 10;
                }, 0)
              }}
            </div>
          </div>
        </div>
        <div class="actBar">
          <el-button type="primary" plain @click="fullScore"
            >一键满分</el-button
          >
          <el-button type="danger" plain @click="zeroScore">一键零分</el-button>
        </div>
        <div class="actBar">
          <el-button
            type="primary"
            @click="preThesis"
            :disabled="!paperIndex"
            style="width: 35%"
            >上一个</el-button
          >

          <el-button
            type="primary"
            @click="nextThesis"
            style="width: 35%; margin-left: 0"
            :disabled="paperIndex > paperList.length - 2"
            >下一个</el-button
          >
        </div>
        <div class="actBar">
          <el-button
            type="primary"
            style="width: 80%"
            @click="submitScore(true, false)"
            >保存并退出</el-button
          >
        </div>
        <div class="actBar">
          <el-button
            type="primary"
            style="width: 80%"
            :disabled="!ifAllCompelete"
            @click="submitScore(true, true)"
            >提交并获取下一批</el-button
          >
        </div>
        <div class="jumperBar">
          <h3
            style="
              margin: 20px 0;
              border-top: 1px solid #ccc;
              border-bottom: 1px solid #ccc;
              padding: 5px 0;
            "
          >
            已阅：{{ finshedCount }}份&ensp;&ensp;共：{{ paperList.length }}份
          </h3>

          <div class="jumperPage">
            <div
              class="pageBtn"
              @click="paperIndex = index"
              :class="{
                currentPape: index == paperIndex,
                finshed: paperList[index].scoreItemList.every(
                  (score) => typeof score.score == 'number' || score.score
                ),
              }"
              :style="index == paperIndex ? '' : ''"
              v-for="(item, index) in paperList"
              :key="'pageBtn' + item.id"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title="添加分组"
      :visible.sync="scoreRuleIfShow"
      :append-to-body="true"
    >

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="scoreRuleIfShow = false"
          >确 定
        </el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";

import {
  queryPaperDetailList,
  getPaperList,
  scoreThesis,
} from "@/api/paper.js";
export default {
  data() {
    return {
      pdfData: { pdfUrl: "", pdfIfShow: false },
      paperList: [],
      paperIndex: 0,
      pageLock: true,
      pageTimeout: null,
      scoreRuleIfShow: false,
    };
  },
  filter: {
    totalScoreCalc(scoreList) {
      console.log(scoreList);
      return 0;
      scoreList.reduce((total, item) => {
        console.log(item);
        let bigTotal = Number(total) * 10 + (item.score ? item.score : 0) * 10;
        let back =
          bigTotal % 10 == 0
            ? bigTotal / 10
            : bigTotal / 10 + "." + (bigTotal % 10);
        return back;
      }, 0);
    },
  },
  computed: {
    ifAllCompelete() {
      return this.paperList.every((paper) =>
        paper.scoreItemList.every(
          (score) => typeof score.score == "number" || score.score
        )
      );
    },
    finshedCount() {
      return this.paperList.filter((item) =>
        item.scoreItemList.every(
          (score) => typeof score.score == "number" || score.score
        )
      ).length;
    },
  },
  watch: {
    paperIndex(value) {
      this.pdfData = {
        pdfIfShow: false,
        pdfUrl: this.paperList[value].paperUrl,
      };
      setTimeout(() => {
        this.pdfData.pdfIfShow = true;
      }, 500);
    },
  },

  created() {},
  mounted() {
    // this.getPaperDetailList();
    this.getData();
  },
  methods: {
    submitScore(ifActive, ifContinue) {
      if (
        this.paperList[this.paperIndex].scoreItemList.every(
          (item) => item.score
        )
      ) {
        scoreThesis({
          id: this.paperList[this.paperIndex].id,
          paperGroupId: this.paperList[this.paperIndex].paperGroupId,
          scoreList: this.paperList[this.paperIndex].scoreItemList,
        }).then((data) => {
          if (ifActive) {
            if (ifContinue) {
              this.$message.success("提交成功");
              this.getData();
            } else if (ifContinue === false) {
              this.$message.success("保存成功");
              this.$router.push("/");
            }
          }
        });
      } else {
        this.$message.success("保存成功");
        this.$router.push("/");
      }
    },
    getData() {
      getPaperList().then((data) => {
        data.paperList.forEach((item) => {
          item.ifEdit = false;
        });
        this.paperIndex = 0;
        this.paperList = data.paperList;
        this.pdfData.pdfUrl = data.paperList[0].paperUrl;
        this.pdfData.pdfIfShow = true;
      });
    },
    nextThesis() {
      if (this.pageLock) {
        if (this.paperList[this.paperIndex].ifEdit) {
          this.submitScore();
          this.paperList[this.paperIndex].ifEdit = false;
        }
        this.paperIndex++;
        this.pageLock = false;
        setTimeout(() => {
          this.pageLock = true;
        }, 1000);
      }
    },
    preThesis() {
      if (this.pageLock) {
        if (this.paperList[this.paperIndex].ifEdit) {
          this.submitScore();
          this.paperList[this.paperIndex].ifEdit = false;
        }
        this.paperIndex--;
        this.pageLock = false;
        setTimeout(() => {
          this.pageLock = true;
        }, 1000);
      }
    },
    fullScore() {
      this.paperList[this.paperIndex].ifEdit = true;
      this.paperList[this.paperIndex].scoreItemList.forEach((item) => {
        item.score = Number(item.maxScore);
      });
    },
    zeroScore() {
      this.paperList[this.paperIndex].ifEdit = true;
      this.paperList[this.paperIndex].scoreItemList.forEach((item) => {
        item.score = "0";
      });
    },
    valueCheck(value, score) {
      if (value > Number(score.maxScore)) {
        score.score = Number(score.maxScore);
      } else if (value < 0) {
        score.score = 0;
      } else {
        score.score = Number(value).toFixed(1);
      }
      this.paperList[this.paperIndex].ifEdit = true;
    },
    getPaperDetailList() {
      queryPaperDetailList().then((data) => {
        this.paperList = data;
        this.pdfData.pdfUrl = data[0].paperUrl;
        this.pdfData.pdfIfShow = true;
        console.log(data);
      });
    },
  },

  components: { pdfPreview },
};
</script>

<style scoped lang="less">
.wrapper {
  .thesisTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    background: #fff;
    .nameSide {
      flex: 1;
      text-indent: 30px;
      font-size: 18px;
    }
    .btnSide {
      width: 360px;
      text-align: center;
    }
  }
  .thesisContainer {
    padding: 5px;
    display: flex;
    height: calc(100vh - 150px);
    .thesisShow {
      flex: 1;
      border: 1px solid #ccc;
      margin-right: 10px;
      overflow-x: hidden;
      overflow-y: auto;
      // &::-webkit-scrollbar {
      //   display: none; /* Chrome Safari */
      // }
    }
    .thesisInAll {
      width: 360px;
      padding: 0 30px;
      background: #fff;
      .detail {
        line-height: 30px;
        font-size: 14px;
      }

      .scoreList {
        border-top: 1px solid #aaa;
        border-left: 1px solid #aaa;
        margin-bottom: 15px;

        .titleBar {
          background: #eee;
        }
        .scoreBar {
          display: flex;
          .cell {
            border-bottom: 1px solid #aaa;
            border-right: 1px solid #aaa;
            line-height: 26px;
            text-align: center;
            flex: 1;
            .scoreInput {
              height: 100%;
              width: 100%;
              border: none;
              background: none;
              text-align: center;
            }
          }
        }
      }
      .actBar {
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: space-evenly;
      }
      .jumperBar {
        .jumperPage {
          display: flex;
          flex-wrap: wrap;
          background: rgba(0, 0, 0, 0.03);
          border-radius: 5px;
          max-height: 400px;
          overflow-x: hidden;
          overflow-y: auto;
          padding: 15px;
          .pageBtn {
            width: 42px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            border: 1px solid #666;
            border-radius: 50%;
            margin: 6px;
            cursor: pointer;
            color: #666;
            font-size: 18px;
          }
          .currentPape {
            transform: scale(1.1);
            box-shadow: 0px 0px 10px #618afd;
            border: 1px solid #618afd;
            color: #618afd;
          }
          .finshed {
            background: #618afd;
            color: #fff;
            border: 1px solid #618afd;
          }
        }
      }
    }
  }
}
</style>
